<template>
  <div class="home">
    <v-progress-linear
      :active="loadingBar"
      :indeterminate="loadingBar"
      bottom
      color="deep-purple accent-4"
    ></v-progress-linear>

    <Dashboard @loadOn="loadingBarStart" @loadOff="loadingBarEnd" />
  </div>
</template>

<script>
import Dashboard from '@/components/Dashboard';

export default {
  name: 'Home',

  data: () => ({
    loadingBar: false,
  }),
  components: {
    Dashboard,
  },
  methods: {
    loadingBarStart() {
      this.loadingBar = true;
    },
    loadingBarEnd() {
      this.loadingBar = false;
    },
  },
};
</script>

<style scoped>
.home {
  /* background: #f6f7fc; */
  color: #3f51b5;
}
.theme--dark.v-data-table {
  background-color: #131836;
  color: #ffffff;
}
</style>
